/* epgAnchorImage.tsx */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';
import withImage from '@shared/components/utils/hoc/withImage';

const EpgAnchorImage = styled.img<React.CSSProperties>`
  height: ${Screen.widthRatio * 60}px;
`;

export default withImage(EpgAnchorImage);
